import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { Button, Col, Form, Row } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import { Modal, Select, Input, DatePicker, CustomDatePicker } from 'components';
import { useStore } from 'store';
import { fetchEventTypes } from 'store/actions/catalogs';
import { setGiftTableSearchValues } from 'store/actions/giftTable';
import { isThereEvenAValue } from 'util/validations';
import { useWindowSize } from 'hooks';
import { initialValues, schema } from './config';
// eslint-disable-next-line no-unused-vars
import styles from './styles.module.scss';

const TableSearchModalHome = ({ onClose, show }) => {
  const [state, dispatch] = useStore();
  const { catalogs, giftTable } = state;
  const { eventTypes = [] } = catalogs;
  const { giftTableSearchValues = {} } = giftTable;
  const [, { isMobile }] = useWindowSize();

  const history = useHistory();

  const handleSubmit = (values) => {
    // alert(JSON.stringify(values, null, 2));
    if (!isThereEvenAValue(values)) return;

    dispatch(setGiftTableSearchValues(values));

    history.push('/buscar-evento');
    window.sessionStorage.setItem('clickHomeSearch', 'true')
  };

  useEffect(() => {
    dispatch(fetchEventTypes());
  }, []);

  return (
    <Formik
      initialValues={{ ...initialValues, ...giftTableSearchValues }}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form onSubmit={formikProps.handleSubmit} className={styles.maxbusqueda}>
          
          
          <Row className={`align-items-center ${styles.customrow}`}>
            <Col xs={12} md={3} className="mb-sm-0">
              <h3 className={styles.h3form}>Encuentra una mesa de regalos</h3>
            </Col>
            
            <Col xs={12} sm={6} md={3} className={`mb-sm-0 ${styles['inputs-container']}`}>
              <Input
                labelClassName="text-left"
                label="Nombre de los festejados"
                name="eventName"
                placeholder=""
                maxLength={50}
              />
            </Col>
            
            <Col xs={12} sm={6}  md={3} className={`mb-3 mb-sm-0 ${styles['inputs-container']}`}>
              {!isMobile ? (
                <div className="input-group">
                <DatePicker
                  className="form-control"
                  label="Fecha del evento:"
                  labelClassName="text-left"
                  name="_eventDate"
                  placeholder="dd/mm/aaaa"
                  // placeholderText="dd/mm/aaaa"
                  maxLength={50}
                />
                <div className="input-group-append d-block d-sm-none">
                  <span className="input-group-text bg-white" style={{ display: 'flex', alignItems: 'center', border: 'none' }}>
                    <i className="fa fa-calendar-o" aria-hidden="true" style={{ zIndex: '20', position: 'absolute', right: '10px', top: '60%', transform: 'translateY(-50%)' }} />
                  </span>
                </div>
              </div>
              ) : (
                <Field 
                  name="eventDate" 
                  component={CustomDatePicker} 
                  label='Fecha del evento:'
                  maxLength={50} 
                  inputClassName="col-12 personalInput" />)}
              
            </Col>
            
            <Col xs={12} md={3} className={`mb-3 mb-sm-0 ${styles.btnsub}`}>
              <Button className={`${styles.button} secondaryButton`} block variant="secondary" type="submit">
                Buscar mesa
              </Button>
            </Col>

          </Row>



          {/* <Row>
        <Col xs={12} className="p-0">
          <Input
            label="Número de evento"
            type="text"
            name="eventNumber"
            inputMode="numeric"
            pattern="\d*"
            placeholder=""
            maxLength={10}
          />
          {/*<Select
            label="Tipo de evento"
            name="eventType"
            options={eventTypes}
          />
        </Col>
      </Row> */}
        </Form>
      )}
    </Formik>

  );
};

export default TableSearchModalHome;
